import { ApplicationFilterItemsStore } from "stores/ApplicationFilters/ApplicationFilterItemsStore";
import { useStore } from "utils/useStore";

/**
 * The extended-metadata fields a chart may group by.
 *
 * Shared by the menu (which turns each field into its own entry) and the categorical editor (which
 * resolves the selected field's classifier to load its values), so both agree on which fields
 * count. Inactive fields are excluded, and `isActive === undefined` is treated as active because
 * older field records predate the flag.
 */
export const useGroupableExtendedMetadataFields = () => {
    const applicationFilterItemsStore = useStore(ApplicationFilterItemsStore);

    return applicationFilterItemsStore.extendedMetadataFields.filter(
        (field) => field.isGroupable && field.isActive !== false,
    );
};
